export const DATA_LOCATION   = 'vocento.dtm.data';
export const VOCENTO_ID      = 'ed924dd314b24fbc7af1a00ec99aee0d3b3ef5b9';
export const TAG_MANAGER_URL = `//assets.adobedtm.com/${VOCENTO_ID}/satelliteLib-{{property-id}}.js`;
export const GLOBAL_LIB_VAR  = '_satellite';

export const HEAD_DEPLOY_SELECTOR_ID = 'vtm-head-deploy';
export const BODY_DEPLOY_SELECTOR_ID = 'vtm-body-deploy';

export const currentScript = document.currentScript || (function() {
  const scripts = document.getElementsByTagName('script');
  return scripts[scripts.length - 1];
}());



// WEBPACK FOOTER //
// ./src/constants.js